export const SET_REQUEST_AUTH = 'SET_REQUEST_AUTH'
export const SET_SUCCESS_AUTH = 'SET_SUCCESS_AUTH'
export const SET_FAILURE_AUTH = 'SET_FAILURE_AUTH'

export const SET_MOBILE_AUTH = 'SET_MOBILE_AUTH'
export const SET_TOKEN_AUTH = 'SET_TOKEN_AUTH'
export const DISABLE_LOADING_AUTH = 'DISABLE_LOADING_AUTH'

export const SET_SUCCESS_GET_MESSAGE_AUTH = 'SET_SUCCESS_GET_MESSAGE_AUTH'